import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'company-settings' */ './Company'),
);
